import React, { useState, useEffect } from "react";

import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/System Design Engineering.jpg'
import img2 from '../Assets/Mask group.png'
import img3 from '../Assets/Group 184.png'
import img4 from '../Assets/Group 11.png'
import heading from '../Assets/heading2.png'
import img222 from '../Assets/5-600x473.png'
import bg from '../Assets/Our-Capabilities-1.png'
function SystemDesign() {
      const [activeTab, setActiveTab] = useState(1);
      const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);
      };
  return (
   <>
    <Navbar/>
     {/* <div className='AboutUs-banner'>
        <h3>System Design Engineering</h3>
      

        </div> */}
        <div className="banner-heading">
          <img src={heading}/>
        </div>
        <div className='silicon'>
  <div className='silicon-left'>
<p>Strategic backbone of any technology-driven product</p>

<h3>System Design Engineering</h3>
<br/>
<br/>
<h4>Semicave is a global engineering technology partner with strong industry experience and expertise to deliver end-to-end product development solutions.
<br/>Our comprehensive hardware and software engineering services can help build products from concept to prototype.
<br/>We design hardware platforms using cutting-edge technologies for different application requirements, and our very well-defined design methodology and collaborative approach helps in reducing time-to-market with accelerated development.
</h4>
       
        </div>
          <div className='silicon-right'>
<img src={img}/>
        </div>
        </div>
         <div className="silicon-box">
        <h4>Experience of time-to-market</h4>
        <h3>
          Enabler in System Design

        </h3>
        <p>Semicave focuses on delivering next-gen IoT solutions to our local and global customers, with end-to-end product ownership. As a leading engineering service provider having in-depth knowledge of system design across various segments, we help develop your product keeping in mind the emerging and disruptive technologies with at most industry focus.
<br/>
Leveraging on our maturity and strong industry reputation for SoC/hardware design and embedded SW/FW across varied wireless and networking technologies, we drive product development process based on organising your workflow with standard practices (starting from initial strategy to MVP release).
</p>
<br/>
<ul>
  <li>
    Delivering Next-Gen IoT solutions
  </li>
  <li>

Complete end-to-end product ownership
  </li>

  <li>

Innovation in cutting-edge technologies
  </li>

  <li>

Reputation for excellence & contribution
  </li>

  <li>

Collaborative approach to problem-solving
  </li>

  <li>

Strategic customer engagement models
  </li>

</ul>

<div className="dg-back">
<img src={bg}/>
</div>



        </div>
           <div className='silicon'>
  <div className='silicon-left'>
<p>Empowering IoT Infrastructure Management </p>

<h3>ADDM: Simplifying IoT Edge Management</h3>
<br/>
<br/>
<h4>With a passion for technology and a commitment to excellence, we empower businesses to thrive in the digital landscape. Semicave’s ADDM is dedicated to crafting tech solutions that revolutionize the way businesses operate. Our product-based solution simplifies IoT Edge Infrastructure management, empowering organizations with seamless control and agility.
<br/><br/>Our cutting-edge solution is tailored specifically for IoT deployments, providing unparalleled provisioning and control over Edge & Fog infrastructure. With the ADDM controller (ADDMCon) at its core, ADDM streamlines application orchestration, simplifies provisioning with single-click functionality, and ensures efficient configuration management. This accelerates IoT deployments, fostering agility within Edge and Fog networks. Moreover, ADDMCon’s machine-assisted troubleshooting and debugging capabilities empower staff to swiftly identify and rectify infrastructure issues. We are dedicated to realizing this vision and eliminating barriers to IoT adoption.
</h4>
       
        </div>
          <div className='silicon-right'>
<img src={img222}/>
        </div>
        </div>
      
        {/* <div className='one-stop'>
<div className='services-heading'>
<p>One-Stop Soc Development Services Provider</p>
<h3>System Design Expertise</h3>
    </div>

        </div>
           <div className="tab-container">
                <div className="tabs">
                  <button
                    className={activeTab === 1 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(1)}>
               From Vision to Certification: Innovating Success
                  </button>
                      <button
                    className={activeTab === 2 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(2)}>
                 Experience in Accelerated Time-to-Market
                  </button>
                  <button
                    className={activeTab === 3 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(3)}>
                   End-to-End Product Ownership
                  </button>
                  <button
                    className={activeTab === 4 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(4)}>
                     IoT Innovation & Deployment
                  </button>
                   <button
                    className={activeTab === 5 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(5)}>
                   Collaborative Problem Solving & Strategic Partnerships
                  </button>
                   <button
                    className={activeTab === 6 ? "tab-btn active" : "tab-btn"}
                    onClick={() => handleTabChange(6)}>
                    Proven Reputation & Industry Focus
                  </button>

                  
                  
                </div>

                <br />
                <br />
                <div className="tab-content">
                  {activeTab === 1 && <>
                 <div className='silicon' style={{padding:'0'}}>
  <div className='silicon-left'>


<h3> From Vision to Certification: Innovating Success</h3>
<br/>
<br/>
<h4>We support clients across the full lifecycle of system design—from initial vision and concept to final testing and certification. By integrating cross-domain hardware and software development, we deliver robust product designs aligned with market needs and compliance standards.</h4>

        </div>
          <div className='silicon-right'>
<img src={img3}/>
        </div>
        </div>
          
                  </> }
                  {activeTab === 2 && (
                   <>
                  <div className='silicon' style={{padding:'0'}}>
  <div className='silicon-left'>


<h3>  Experience in Accelerated Time-to-Market</h3>
<br/>
<br/>
<h4>Our expertise allows us to organize and streamline workflows using standardized engineering practices. From strategy to MVP release, we ensure product development is fast, efficient, and aligned with your go-to-market timeline.</h4>
<br/>
<ul>
  <li>Deep experience in wireless, networking, and embedded domains</li>
  <li>Agile, sprint-based execution</li>
  <li>Quality-first strategy with automation and reuse</li>

</ul>

        </div>
          <div className='silicon-right'>
<img src={img3}/>
        </div>
        </div>
                   </>
                  )}

                  {activeTab === 3 && (
                     <>
                  <div className='silicon' style={{padding:'0'}}>
  <div className='silicon-left'>


<h3>End-to-End Product Ownership</h3>
<br/>
<br/>
<h4>Semicave assumes full product ownership, offering clients peace of mind from concept to completion. Whether it's a hardware platform, embedded software stack, or connectivity module, we handle every stage of system realization under one roof.</h4>
<ul>
    <li>System architecture design</li>
    <li>Hardware/PCB development</li>
    <li>Embedded software & firmware</li>
    <li>Testing, validation, and certification support</li>

</ul>


        </div>
          <div className='silicon-right'>
<img src={img3}/>
        </div>
        </div>
                   </>
                  )}

                      {activeTab === 4 && (
                     <>
                  <div className='silicon' style={{padding:'0'}}>
  <div className='silicon-left'>


<h3>IoT Innovation & Deployment</h3>
<br/>
<br/>
<h4>We focus heavily on building IoT infrastructure, optimizing both Edge and Fog deployments. Our specialized solution—ADDM (Agile Device & Deployment Management)—simplifies provisioning, monitoring, and control of distributed IoT systems, enabling intelligent automation at the edge.</h4>

<ul>
    <li>One-click provisioning and orchestration</li>
    <li>Edge/Fog infrastructure visibility and control</li>
    <li>Machine-assisted troubleshooting</li>
    <li>Scalable deployment across industries</li>

</ul>

        </div>
          <div className='silicon-right'>
<img src={img3}/>
        </div>
        </div>
                   </>
                  )}
                      {activeTab === 5 && (
                     <>
                  <div className='silicon' style={{padding:'0'}}>
  <div className='silicon-left'>


<h3>Collaborative Problem Solving & Strategic Partnerships</h3>
<br/>
<br/>
<h4>Our approach is based on deep collaboration and flexible engagement models. We tailor our involvement based on the client's internal capabilities, taking on complete projects or integrating with in-house teams to fill key expertise gaps.</h4>



        </div>
          <div className='silicon-right'>
<img src={img3}/>
        </div>
        </div>
                   </>
                  )}
                    {activeTab === 6 && (
                     <>
                  <div className='silicon' style={{padding:'0'}}>
  <div className='silicon-left'>


<h3>Proven Reputation & Industry Focus</h3>
<br/>
<br/>
<h4>With a reputation built on innovation and delivery, Semicave is recognized for its contributions to next-generation IoT and system-based products. We bring technical maturity, domain knowledge, and a consultative approach to every engagement.

</h4>



        </div>
          <div className='silicon-right'>
<img src={img3}/>
        </div>
        </div>
                   </>
                  )}
                </div>
              </div> */}

    <Footer/>

</>
  )
}

export default SystemDesign